import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PageTitle from '../Common/PageTitle';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    list: {
        width: '100%',
    },
    item: {
        flexWrap: 'wrap',
    },
    text: {
        width: '100%',
        padding: `0px ${theme.spacing.unit * 2}px`,
        '&:first-child': {
            padding: `0px ${theme.spacing.unit * 2}px`,
        },
    },
    name: {
        fontWeight: theme.typography.fontWeightMedium,
    }
});

interface Props {
    getLeaderboard: (params?: Bee.Params) => any;
    classes: {
        container: string;
        list: string;
        item: string;
        text: string;
        name: string;
    }
}

interface State {
    leaderboard: any[];
}

class LeaderboardPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            leaderboard: [],
        }
    }

    componentDidMount() {
        this.onMount();
    }

    private onMount = async () => {
        const leaderboard = await this.props.getLeaderboard();
        if (leaderboard) {
            this.setState({ leaderboard });
        }
    }

  	render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <PageTitle title={'Leaderboard'} />
                    {this.state.leaderboard.length ?
                        <List className={classes.list}>
                            <Divider />
                            {this.state.leaderboard.map((leader: Bee.Leader) => (
                                <ListItem className={classes.item} key={leader.username} divider>
                                    <ListItemText
                                        className={classes.text}
                                        primary={leader.name}
                                        primaryTypographyProps={{ align: 'center', variant: 'h6' }}
                                    />
                                    <ListItemText
                                        className={classes.text}
                                        primary={`Score: ${leader.score}`}
                                        primaryTypographyProps={{ align: 'center' }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    :
                        <Typography>No user scores available</Typography>
                    }
            </div>
        );
	}
}

export default withStyles(jss)(LeaderboardPage);



// WEBPACK FOOTER //
// ./src/components/Leaderboard/LeaderboardPage.tsx